import { Button } from '@app/shared/ui/atoms/Common';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationSectionProps {
  page: number;
  totalPages: number;
  onPrevPage: () => void;
  onNextPage: () => void;
}

const BUTTON_CLASS_NAME =
  'flex size-9 items-center justify-center rounded-full border border-accent text-accent disabled:border-gray-neutral disabled:text-gray-neutral';

export function PaginationSection({
  page,
  totalPages,
  onPrevPage,
  onNextPage,
}: PaginationSectionProps) {
  return (
    <section className="flex items-center justify-center">
      <Button
        variant="custom"
        className={BUTTON_CLASS_NAME}
        onClick={onPrevPage}
        disabled={page <= 1}
      >
        <ChevronLeft className="size-4/5" />
      </Button>
      <div className="flex-1 text-center text-xl">{page}</div>
      <Button
        variant="custom"
        className={BUTTON_CLASS_NAME}
        onClick={onNextPage}
        disabled={page >= totalPages}
      >
        <ChevronRight className="size-4/5" />
      </Button>
    </section>
  );
}
